export const SITE_PROTOCOLS = {
	HTTPS: 'https://',
	HTTP: 'http://',
};

export const SITE_PROTOCOL_OPTIONS = [
	{ label: 'https://', value: SITE_PROTOCOLS.HTTPS },
	{ label: 'http://', value: SITE_PROTOCOLS.HTTP },
];

const normalizeProtocol = (protocol) =>
	String(protocol ?? '')
		.toLowerCase()
		.startsWith('http://')
		? SITE_PROTOCOLS.HTTP
		: SITE_PROTOCOLS.HTTPS;

export const splitSiteUrl = (value) => {
	const trimmed = String(value ?? '').trim();

	if (!trimmed) {
		return { protocol: SITE_PROTOCOLS.HTTPS, host: '' };
	}

	const match = trimmed.match(/^(https?:\/\/)(.*)$/i);

	if (match) {
		return {
			protocol: normalizeProtocol(match[1]),
			host: match[2],
		};
	}

	return {
		protocol: SITE_PROTOCOLS.HTTPS,
		host: trimmed,
	};
};

export const joinSiteUrl = (protocol, host) => {
	const trimmedHost = String(host ?? '').trim();

	if (!trimmedHost) return '';

	if (/^https?:\/\//i.test(trimmedHost)) {
		const split = splitSiteUrl(trimmedHost);
		return `${split.protocol}${split.host}`;
	}

	return `${normalizeProtocol(protocol)}${trimmedHost}`;
};
